import { render, staticRenderFns } from "./UnDeletedPage.vue?vue&type=template&id=a19e0a78&"
import script from "./UnDeletedPage.vue?vue&type=script&lang=js&"
export * from "./UnDeletedPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports